<template>
  <div class="article-categories">
    <button v-if="groups.length" type="button" class="category-summary" :title="fullText" :aria-label="'전체 카테고리: ' + fullText" @click.stop="open = true">
      <span v-for="group in groups" :key="group.label" class="category-line">
        <span class="category-label">{{ group.label }}</span>
        <span class="category-path">{{ group.paths[0] }}</span>
        <span v-if="group.paths.length > 1" class="category-more">+{{ group.paths.length - 1 }}</span>
      </span>
    </button>
    <span v-else class="category-empty">{{ fallback || '—' }}</span>
    <div v-if="open" ref="overlay" class="category-overlay" @click.stop="open = false" @keydown.esc="open = false">
      <section role="dialog" aria-modal="true" aria-label="전체 카테고리" class="category-dialog" @click.stop>
        <header><strong>전체 카테고리</strong><button ref="close" type="button" @click="open = false">닫기</button></header>
        <div v-for="group in groups" :key="group.label" class="category-detail">
          <strong>{{ group.label }}</strong><p v-for="path in group.paths" :key="path">{{ path }}</p>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  props: { categories: { type: Array, default: () => [] }, fallback: { type: String, default: '' } },
  data: () => ({ open: false }),
  computed: {
    groups() {
      return [1, 2, 0].map(number => {
        const items = this.categories.filter(item => Number(item.category_group) === number);
        const parents = new Map();
        items.forEach(item => {
          const key = item.parent_code || item.code;
          if (!parents.has(key)) parents.set(key, { name: item.parent_name || item.name, children: [] });
          if (item.parent_code && !parents.get(key).children.includes(item.name)) parents.get(key).children.push(item.name);
        });
        return { label: number ? number + '차' : '기타', paths: Array.from(parents.values()).map(item => item.name + (item.children.length ? ' › ' + item.children.join(' · ') : '')) };
      }).filter(group => group.paths.length);
    },
    fullText() { return this.groups.map(group => group.label + ': ' + group.paths.join(' / ')).join('\n'); }
  },
  beforeDestroy() { if (this.$refs.overlay) this.$refs.overlay.remove(); },
  watch: { open(value) { this.$nextTick(() => {
    if (value) {
      document.body.appendChild(this.$refs.overlay);
      this.$refs.close.focus({ preventScroll: true });
    } else {
      const summary = this.$el.querySelector('.category-summary');
      if (summary) summary.focus({ preventScroll: true });
    }
  }); } }
};
</script>
<style scoped>
.article-categories{width:210px;max-width:210px;font-size:12px;font-weight:400;text-align:left}
.category-summary{display:block;width:100%;padding:4px 0;border:0;background:transparent;color:#394553;text-align:left;font:inherit;cursor:pointer}
.category-line{display:flex;align-items:center;gap:6px;line-height:1.7;white-space:nowrap}
.category-label{flex:none;color:#7b8490;font-size:11px}.category-path{overflow:hidden;text-overflow:ellipsis;min-width:0}.category-more{flex:none;color:#526783;font-size:11px}
.category-empty{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:#7b8490}
.category-overlay{position:fixed;inset:0;z-index:100001;background:#0005;display:flex;align-items:center;justify-content:center;padding:20px;white-space:normal}
.category-dialog{background:white;border-radius:8px;padding:20px;width:420px;max-width:100%;max-height:75vh;overflow:auto;box-shadow:0 8px 30px #0003;font-size:14px}
.category-dialog header{display:flex;align-items:center;justify-content:space-between;margin-bottom:16px}.category-dialog button{border:1px solid #ccd2da;background:white;border-radius:4px;padding:7px 12px;cursor:pointer}.category-detail{margin-top:14px}.category-detail strong{color:#6d7884;font-size:12px}.category-detail p{margin:6px 0;line-height:1.6;overflow-wrap:anywhere}
@media(max-width:768px){.article-categories{width:170px;max-width:170px}}
</style>
